import { render } from "./UploadTemplate.vue?vue&type=template&id=e5f3541c&scoped=true"
import script from "./UploadTemplate.vue?vue&type=script&lang=js"
export * from "./UploadTemplate.vue?vue&type=script&lang=js"

import "./UploadTemplate.vue?vue&type=style&index=0&id=e5f3541c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\34\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f3541c"]])

export default __exports__